// URL of a deployed HTTP Cloud Function.
//
// TSF-323 (2026-10-20): auth.ts built `import.meta.env.VITE_FIREBASE_FUNCTIONS_URL + '/sendVerificationEmail'`,
// but that variable is set in no build environment, so the live bundle shipped
// fetch("undefined/sendVerificationEmail") -- sign-up verification, "Resend
// verification email", password reset and "Email this post" all posted to a
// path that does not exist. Derive the base from the project id instead: every
// build has it (Firebase cannot start without it). functionsUrl.test.ts guards it.
type Env = Record<string, unknown>;

// Named fields, not the bare import.meta.env: Vite inlines the bare object
// whole, which would ship every VITE_ var in the bundle.
const buildEnv = (): Env => ({
  VITE_FIREBASE_FUNCTIONS_URL: import.meta.env.VITE_FIREBASE_FUNCTIONS_URL,
  VITE_FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID,
});

export function functionsUrl(name: string, env: Env = buildEnv()): string {
  const explicit = env.VITE_FIREBASE_FUNCTIONS_URL;
  const project = env.VITE_FIREBASE_PROJECT_ID;
  const base =
    typeof explicit === 'string' && explicit
      ? explicit
      : typeof project === 'string' && project
        ? `https://us-central1-${project}.cloudfunctions.net`
        : '';
  if (!/^https?:\/\//.test(base)) {
    throw new Error('Cloud Functions URL is not configured');
  }
  return `${base.replace(/\/$/, '')}/${name}`;
}
